export class OutroVinculo {
    id: number
    cpf: string
    cnpj: string
    tipo: number
    categoria: number
    categoriaDescricao: string

    constructor(cpf: string, cnpj: string, tipo: number, categoria: number, categoriaDescricao: string) {
        this.cpf = cpf
        this.cnpj = cnpj
        this.tipo = tipo
        this.categoria = categoria
        this.categoriaDescricao = categoriaDescricao
    }
}